/**
 * cp-reveal.js — 通地網格設計系統的進場動效（PRD-1 M1）
 * 掃描 [data-cp-reveal]，進入視窗時加上 .cp-revealed。
 * 無 JS 時內容照常顯示（隱藏樣式僅在 .cp-motion 之下生效）。
 */

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('cp-revealed');
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
);

function init(root = document) {
  const targets = root.querySelectorAll('[data-cp-reveal]:not([data-cp-observed])');
  if (!targets.length) return;

  document.documentElement.classList.add('cp-motion');

  for (const el of targets) {
    el.setAttribute('data-cp-observed', '');
    if (REDUCED) {
      el.classList.add('cp-revealed');
    } else {
      observer.observe(el);
    }
  }
}

init();

// theme editor 內重新載入 section 時再跑一次
document.addEventListener('shopify:section:load', (event) => init(event.target));
